import {
  R1_NETWORK_GET_URL,
  R1_NETWORK_NOTIFICATIONS_BANNER_UPDATE_URL,
  R1_NETWORK_NOTIFICATIONS_COUNTRY_BANNER_UPDATE_URL,
  R1_NETWORK_NOTIFICATIONS_COUNTRY_PROMOTION_UPDATE_URL,
  R1_NETWORK_NOTIFICATIONS_EMAIL_ADD_URL,
  R1_NETWORK_NOTIFICATIONS_EMAIL_REMOVE_URL,
  R1_NETWORK_NOTIFICATIONS_PROMOTION_UPDATE_URL,
  R1_NETWORK_SUBSCRIBE_URL,
  R1_NETWORK_UPDATE_RETURN_URL,
  R1_NETWORK_UPDATE_URL,
} from '@1po/1po-bff-fe-spec/generated/backoffice/BackofficeURLs';
import { AddEmailToNotificationList } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/AddEmailToNotificationList';
import { ChangeNotifyOnNewBanner } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/ChangeNotifyOnNewBanner';
// eslint-disable-next-line max-len
import { ChangeNotifyOnNewCountryBanner } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/ChangeNotifyOnNewCountryBanner';
// eslint-disable-next-line max-len
import { ChangeNotifyOnNewCountryPromotion } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/ChangeNotifyOnNewCountryPromotion';
import { ChangeNotifyOnNewPromotion } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/ChangeNotifyOnNewPromotion';
// eslint-disable-next-line max-len
import { RemoveEmailFromNotificationList } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/RemoveEmailFromNotificationList';
import { SaveR1NetworkRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/SaveR1NetworkRequest';
// eslint-disable-next-line max-len
import { SaveReturnsFeatureSettingsRequest } from '@1po/1po-bff-fe-spec/generated/backoffice/r1_network/request/SaveReturnsFeatureSettingsRequest';

import { BACKOFFICE_SAVE_RETURNS_FEATURE_SETTINGS_RESPONSE } from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import {
  GET_MY_NETWORK_CLIENTS_URL,
  UPDATE_MY_NETWORK_CLIENTS_CONFIG_URL,
} from '@1po/1po-bff-fe-spec/generated/common/WebsocketConstants';
import { MyNetworkClientsRequest } from '@1po/1po-bff-fe-spec/generated/my_network/request/MyNetworkClientsRequest';
import { UpdateMyNetworkClientRequest } from '@1po/1po-bff-fe-spec/generated/my_network/request/UpdateMyNetworkClientRequest';
import { RequestResponseMappingManager } from 'domains/webSockets/WebSocket.requestsResponseMapping';
import { WebSocketAction } from 'utils';
import { wsSendAction } from 'utils/domainStore/api';

RequestResponseMappingManager.addMapping(R1_NETWORK_UPDATE_URL, BACKOFFICE_SAVE_RETURNS_FEATURE_SETTINGS_RESPONSE);

export function sendSaveReturnsFeatureSettingsRequest(request: SaveReturnsFeatureSettingsRequest): WebSocketAction {
  return wsSendAction(R1_NETWORK_UPDATE_RETURN_URL, request);
}

export function sendSaveR1Network(request: SaveR1NetworkRequest): WebSocketAction {
  return wsSendAction(R1_NETWORK_UPDATE_URL, request);
}

export function sendGetR1NetworkRequest(): WebSocketAction {
  return wsSendAction(R1_NETWORK_GET_URL, null);
}

export function sendSubscribeR1NetworkRequest(): WebSocketAction {
  return wsSendAction(R1_NETWORK_SUBSCRIBE_URL, null);
}

export function sendChangeNotifyOnNewPromotion(request: ChangeNotifyOnNewPromotion): WebSocketAction {
  return wsSendAction(R1_NETWORK_NOTIFICATIONS_PROMOTION_UPDATE_URL, request);
}

export function sendChangeNotifyOnNewBanner(request: ChangeNotifyOnNewBanner): WebSocketAction {
  return wsSendAction(R1_NETWORK_NOTIFICATIONS_BANNER_UPDATE_URL, request);
}

export function sendChangeNotifyOnNewCountryPromotion(request: ChangeNotifyOnNewCountryPromotion): WebSocketAction {
  return wsSendAction(R1_NETWORK_NOTIFICATIONS_COUNTRY_PROMOTION_UPDATE_URL, request);
}

export function sendChangeNotifyOnNewCountryBanner(request: ChangeNotifyOnNewCountryBanner): WebSocketAction {
  return wsSendAction(R1_NETWORK_NOTIFICATIONS_COUNTRY_BANNER_UPDATE_URL, request);
}

export function sendAddEmailToNotificationList(request: AddEmailToNotificationList): WebSocketAction {
  return wsSendAction(R1_NETWORK_NOTIFICATIONS_EMAIL_ADD_URL, request);
}

export function sendRemoveEmailFromNotificationList(request: RemoveEmailFromNotificationList): WebSocketAction {
  return wsSendAction(R1_NETWORK_NOTIFICATIONS_EMAIL_REMOVE_URL, request);
}

export function sendGetMyNetworkClients(request: MyNetworkClientsRequest): WebSocketAction {
  return wsSendAction(GET_MY_NETWORK_CLIENTS_URL, request);
}

export function sendUpdateMyNetworkClients(request: UpdateMyNetworkClientRequest): WebSocketAction {
  return wsSendAction(UPDATE_MY_NETWORK_CLIENTS_CONFIG_URL, request);
}
